import { Spinner } from 'react-bootstrap';
import useChangePasswordForm from './useChangePasswordForm';
import { useNavigate } from 'react-router-dom';
import { PasswordValidator } from '../../../components/ui/PasswordValidator/PasswordValidator';
import styles from './ChangePasswordForm.module.css';

export const ChangePasswordForm = () => {
  const navigate = useNavigate();
  const password = useChangePasswordForm();
  return (
    <div className="page-container mt-2">
      <div className={styles.formContainer}>
        {password.changeResult !== null && password.changeResult && (
          <>
            <div className="alert alert-success">
              Your password has been successfully changed. An email has been sent for confirmation.{' '}
            </div>
            <div>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/')}>
                Return to Dashboard
              </button>
            </div>
          </>
        )}
        {password.changeResult !== null && !password.changeResult && (
          <>
            <div className="alert alert-danger">
              There was an error updating your password. Please try again later or contact your
              administrator.
            </div>
            <div>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/')}>
                Return to Dashboard
              </button>
            </div>
          </>
        )}
        {password.changeResult == null && (
          <form onSubmit={(e) => password.handleSubmit(e)}>
            <div className="form-group">
              <PasswordValidator
                isValidCallback={password.passwordCallback}
                passwordOptions={{
                  requireCurrentPassword: true,
                  requireLowercase: true,
                  requireUppercase: true,
                  requireNumber: true,
                  requireSymbol: true,
                  minimumLength: 8
                }}
              />
              <div className="mt-2">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!password.validatorResult.isValid || password.submitted}>
                  Change Password{' '}
                  {password.submitted && <Spinner size="sm" animation="border" className="ms-2" />}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
